import T from 'i18n-react'
import {
  createSelectorWithPath,
  createSelectorWithEntity,
  labelSelectorFunc
} from 'helpers/ComponentSelectorUtil'

const valuesSelectorFunc = state => (state.values[0]) ? state.values[0].value : 'Green'
const sourcesSelectorFunc = state => state.sources

const sourcesResultFunc = (entities, refs) => (
  refs.map(({id, type}) => {
    const value = entities[type][id].value
    return ({
      value,
      label: value,
      color: {
        borderColor: 'black',
        backgroundColor: value
      }
    })
  })
)

export default (path) => {
  const withPath = createSelectorWithPath(path)
  const valuesSelector = withPath(valuesSelectorFunc)
  const sourceSelectorWithPath = withPath(sourcesSelectorFunc)
  const sourceSelector = createSelectorWithEntity(sourceSelectorWithPath, sourcesResultFunc)
  const labelSelector = withPath(labelSelectorFunc)
  return {
    valuesSelector,
    sourceSelector,
    labelSelector,
  }
}
